module.exports = __webpack_public_path__ + "assets/img/1.198ef24b.jpg";